<template>
  <TsButton
    :data-testid="collectionCTATestid"
    :disabled="isClickAndCollectDisabled()"
    :label="getClickAndCollectLabel().label"
    @click="emit('collect')"
  />
</template>

<script lang="ts" setup>
const productStore = useProductStore();
const branchStore = useBranchStore();

type Props = {
  isSticky?: boolean;
};

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits(["collect"]);

const collectionCTATestid = computed(() => {
  return (
    `pdp-${productStore.product.slug}` +
    `-${getClickAndCollectLabel().testId}` +
    (props.isSticky ? "-sticky" : "")
  );
});

function isClickAndCollectDisabled() {
  if (!branchStore.is_branch_set) return false;
  if (productStore.is_product_stock_loading) return true;
  if (
    Number(productStore.quantity_to_add) >
      Number(productStore.delivery_stock) &&
    Number(productStore.quantity_to_add) > Number(productStore.collection_stock)
  )
    return true;
  return !productStore.collection_stock && !productStore.delivery_stock;
}

// Responsible for determining the label and testId for the PDP collection CTA
function getClickAndCollectLabel() {
  if (!productStore.collection_stock && branchStore.is_branch_set) {
    return {
      testId: "next-day-collection-btn",
      label: useTranslation("nextDayCollection", "Ophalen de volgende dag"),
    };
  }
  if (
    branchStore.is_branch_set &&
    Number(productStore.quantity_to_add) >
      Number(productStore.collection_stock) &&
    productStore.delivery_stock &&
    productStore.delivery_stock > 0
  ) {
    return {
      testId: "next-day-collection-btn",
      label: useTranslation("nextDayCollection", "Ophalen de volgende dag"),
    };
  }
  return {
    testId: "collection-btn",
    label: useTranslation("collection", "Verzameling"),
  };
}
</script>
